import Loadable from 'react-loadable'
import Loading from '../../components/Loading'

export const PrinterSelection = Loadable({
  loader: () => import('./containers/PrinterSelection'),
  loading: Loading
})



// WEBPACK FOOTER //
// ./src/containers/PrinterSetup/index.js